import CmsImageBlock from './cms-image-block'

export default CmsImageBlock
